<template>
  <div class="modal fade" :id="id" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <form @submit.prevent="paidExpense" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('expenses.paid') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
              <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor" />
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>

          <div class="modal-body">

              <div class="d-flex justify-content-between align-content-center rounded p-5 bg-light-primary">
                <div class="row">
                  <span class="title">{{expense.title}}</span>
                  <span class="subtitle">{{ $t('expenses.created') }}: {{new Date(expense.created_at).toLocaleDateString()}}</span>
                  <span class="subtitle" >{{ $t('expenses.valid') }} {{new Date(expense?.approved_at).toLocaleDateString()}}</span>
                  <span class="subtitle" >{{ $t('expenses.users_account') }} : {{expense.user?.fullname}}</span>
                </div>
                <div class="row">
               <span class="badge badge-sm mb-5 d-flex align-items-center justify-content-center text-white w-100px"
                     :class="`bg-${expense?.status_color}`"
                     style="text-align: center;">
                    {{ expense['status_'+locale] }}
                </span>

                  <span class="subtitle">{{ $t('expenses.totalAmount') }} {{ formatAmount(expense?.fees_sum_amount) }} </span>
                  <span>{{ $t('expenses.remaining') }}
                    {{ expense?.status === expenseStatusEnums.VALIDATED
                        ? formatAmount(expense?.fees_sum_amount)
                        : formatAmount(expense?.remaining)
                    }}
                  </span>
                </div>

            </div>
            <hr style="border: 1px solid #ddd; margin: 10px 0;">

            <div class="container d-flex justify-content-between align-content-center p-5 bg-light-dark rounded-1 mb-5">
              <span  class="sub">{{ $t('expenses.operation') }}</span>
              <span  class="sub">{{ $t('expenses.selected') }}  </span>
            </div>

            <div v-for="(paiement, index) in formData.deposits" :key="index">
              <div class="d-flex justify-content-center gap-12 mb-5">
                <label class="form-label flex items-center gap-2.5 text-nowrap">
                  <input checked class="radio me-2" :name="`radio2-${index}`"  type="radio" value="account" v-model="paiement.type" @change.prevent="() => resetRow(paiement)"
                         style="transform: scale(1.5);"/>

                  <span class="sub"> {{ $t('expenses.account') }}</span>


                </label>
                <label class="form-label flex items-center gap-2.5 text-nowrap">
                  <input  class="radio me-2" :name="`radio2-${index}`" type="radio" value="box" v-model="paiement.type"  style="transform: scale(1.5);" @change.prevent="() => resetRow(paiement)"/>
                  <span class="sub">  {{ $t('expenses.boxed') }}</span>

                </label>
              </div>


              <div class="row">
                <Select2
                    v-if="paiement.type === 'account'"
                    container-class="form-group col-12 col-md-6 mb-7"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    :name="`account-${index}`"
                    :label="$t('expenses.label.account')"
                    labelClass="form-label fs-6 text-black"
                    :placeholder-text="$t('expenses.label.account')"
                    :parent-id="'#'+id"
                    v-model="paiement.id"
                    @update:modelValue="() => togglePaymentCurrency(paiement)"
                >
                  <option v-for="account in accounts" :key="account.id" :value="account.id">
                    {{ account.name }}
                  </option>
                </Select2>
                <Select2
                    v-if="paiement.type === 'box'"
                    container-class="form-group col-12 col-md-6 mb-7"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-sm form-select-solid'"
                    :name="`box-${index}`"
                    :label="$t('expenses.label.fund')"
                    labelClass="form-label fs-6 text-black"
                    :placeholder-text="$t('expenses.label.fund')"
                    :parent-id="'#'+id"
                    v-model="paiement.id"
                    @update:modelValue="() => togglePaymentCurrency(paiement)"
                >
                  <option v-for="boxed in boxes" :key="boxed.id" :value="boxed.id">
                    {{ boxed.name }}
                  </option>
                </Select2>
                <Input
                    container-class="form-group col-12 col-md-5 mb-7"
                    :name="`${id}-name`"
                    type="text"
                    :label="$t('expense.label.amount') + `(${expense?.currency?.symbol})`"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    :placeholder="$t('expense.label.amount')"
                    v-model="paiement.amount"
                    @update:modelValue="() => calReelAmount(paiement)"
                />
                <div v-if="!(paiement.currency && (paiement.currency !== expense?.currency?.symbol))" class="col-md-1 col-lg-1 d-flex justify-content-center align-items-center">
                  <a class="btn btn-sm btn-icon btn-danger p-5" @click="dropPaiement(index)">
                    <i class="bi bi-trash-fill fs-5"></i>
                  </a>
                </div>
              </div>

              <div v-if="paiement.currency && (paiement.currency !== expense?.currency?.symbol)" class="row">
                <Input
                    containerClass="col-12 col-md-6 col-lg-6"
                    name="invoice-exchange"
                    type="text"
                    :label="$t('invoice.label.exchange')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="true"
                    size="lg"
                    :placeholder="$t('invoice.placeholder.exchange')"
                    v-model="paiement.rate"
                    @update:modelValue="() => calReelAmount(paiement)"
                    :IsInputGroup="true"
                    addon-class="border-0 border-end"
                    iconDir="left"
                    :iconText="'1 '+ expense?.currency?.symbol +' ='">
                  <template #rightAddon>
                  <span class="position-absolute end-0 top-50 translate-middle-y me-3 text-muted fw-bolder">
                    {{ paiement.currency }}
                  </span>
                  </template>
                </Input>
                <Input
                    container-class="form-group col-12 col-md-5 mb-7"
                    :name="`${id}-amount-to-remove`"
                    type="text"
                    :label="$t('expense.label.amount') + `(${paiement.currency})`"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    :isRequired="true" size="lg"
                    :placeholder="$t('expense.label.amount')"
                    v-model="paiement.reelAmount"
                    is-disabled
                />
                <div class="col-md-1 col-lg-1 d-flex justify-content-center align-items-center">
                  <a class="btn btn-sm btn-icon btn-danger p-5" @click="dropPaiement(index)">
                    <i class="bi bi-trash-fill fs-5"></i>
                  </a>
                </div>
              </div>

            </div>

            <div class="d-flex justify-content-end mb-4 m-3">
              <Button btn-class="btn-sm me-3"  type="submit" :id="id+'_submit_btn'" @click="addPaiement" btn-text="button.add" size="7px 30px"></Button>
            </div>
          </div>

          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel"></Button>
            <Button btn-class="btn-sm me-3" type="submit" :id="id+'_submit_btn'" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {ref, defineProps, onMounted, computed} from "vue";
import {useStore} from "vuex";

import Button from "@/components/Button.vue"
import { useRoute } from "vue-router";
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import {useSwal} from "@/composables/useSwal";
import {useExpenseEnums} from "@/Modules/Financial/composables/expenseEnums";
import {useLocales} from "@/composables/locales";
import {formatLocale} from "d3-format";
import {useFormatAmount} from "@/composables/formatAmount";
const { expenseStatusEnums } = useExpenseEnums()
const store = useStore()
const route = useRoute()
const emit = defineEmits(['reload'])

defineProps({
  id: { type: String, required: true },
})

const { formatAmount } = useFormatAmount()
const {showSwal} = useSwal()
const isLoading = ref(false)
const { locale } = useLocales()
const formData = ref(
    {
      expense_id: route.params.id,
      deposits: [
        {
          id: "",
          type: "box",
          amount: "0",
          currency: '',
          rate: 1,
          reelAmount: "0"
        }
      ]
    }
)

const accounts = computed(() => store.getters['accounts/getAccounts'])
const boxes = computed(() => store.getters['accounts/getBoxes'])
const expense = computed(() => store.getters['expenses/currentExpense'])


function togglePaymentCurrency (payment) {
  let depositAccount = {}
  if(payment.type === 'box') {
    depositAccount =  (boxes.value?.[payment.id]) || {}
  }else {
    depositAccount = (accounts.value?.[payment.id]) || {}
  }
  payment.currency = depositAccount.currency_symbol
}

function paidExpense() {
  showSwal(
      i18n.global.t('swal.paid'),
      i18n.global.t('swal.paid_text')
  ).then( async (result) => {
    if (result.value) {
      isLoading.value = true
      store.dispatch('expenses/payExpense', formData.value)
          .then(() => {
            emit("reload");
            formData.value = {
              expense_id: null,
              deposits: [{ id: "", type: "box", amount: "" }]
            };
            closeModal()
            window.toastr['success'](i18n.global.t('notification.expense_paid'))

          })
          .catch(() => {
          })
          .finally(() => isLoading.value = false)
    }
  })

}

function calReelAmount(payment) {
  if(!payment.amount) {
    payment.reelAmount = 0
  } else {
    payment.reelAmount = (payment.amount * parseFloat(payment.rate || 1)).toFixed(2)
  }
}

function resetRow(payment) {
  payment.amount = "0"
  payment.account = ""
  payment.currency = ""
  payment.reelAmount = "0"
  payment.rate = 1
}

function addPaiement() {
  formData.value.deposits.push({
    type: 'box',
    amount: "0",
    account:"",
    reelAmount: "0"
  })
}

const dropPaiement = (key) => {
  if(formData.value.deposits.length > 1) {
    formData.value.deposits.splice(key, 1)
  }
}

function closeModal(){
  $("#paid_expense").modal('toggle');
}

onMounted(async () => {

})
</script>

<style scoped>
.title{
  color: black;
  font-size: 15px;
  font-weight: bold;
}
.subtitle{
  color: gray;
  font-size: 15px;
}
.sub{
  font-size: 15px;
}
</style>
